import { BASE_PATH, PNG, UNKNOWN } from "../constants";

const useImageLoader = () => {
    const images = import.meta.glob<{ default: string }>(
        "/src/assets/models/*.{png,jpg,jpeg,webp}",
        { eager: true }
    );

    const getModelImagePath = (modelName: string, suffix: string = "") => {
        const targetName = modelName || UNKNOWN;

        const targetPath = `${BASE_PATH}${targetName}${suffix}${PNG}`;
        const unknownPath = `${BASE_PATH}${UNKNOWN}${suffix}${PNG}`;

        return (
            images[targetPath]?.default ||
            images[unknownPath]?.default ||
            images[`${BASE_PATH}${UNKNOWN}${PNG}`]?.default ||
            ""
        );
    };

    return { getModelImagePath };
};

export { useImageLoader };
